import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-denuncia-detail-dialog',
  templateUrl: './denuncia-detail-dialog.component.html',
  styleUrls: ['./denuncia-detail-dialog.component.css']
})
export class DenunciaDetailDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
